module.exports = __webpack_public_path__ + "img/spiritcatcher-3.8651d112.jpg";